
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentInjectedEvidence, DocumentInjectedGround } from "../../../../../../../domain/document";
import { InjectedObjectGroundModel } from "../models";

@Component
export default class InjectedObjectGroundPresentableMixin extends Mixins() {
  @Prop()
  source: InjectedObjectGroundModel;

  get ground(): DocumentInjectedGround {
    return this.source.ground;
  }

  get reason(): string {
    return this.ground ? this.ground.reason : "";
  }

  get isReliable(): boolean {
    return !!this.ground && this.ground.isReliable;
  }

  get evidences(): DocumentInjectedEvidence[] {
    return this.source.evidences;
  }

  get hasEvidences(): boolean {
    return this.evidences.length > 0;
  }
}
